import { IconButton, ListItemButton, Menu, SvgIcon } from '@mui/material'
import { IconDotsVertical } from '@tabler/icons-react'
import { useState } from 'react'
import { customerRequestStatuses } from '~/features/customers/constants'
import { useUpdateCustomerRequest } from '~/features/customers/hooks/useUpdateCustomerRequest'

export const RequestStatusMenu = ({ id }: { id: number }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClose = () => {
    setAnchorEl(null)
  }

  const { mutate: updateRequest, isPending } = useUpdateCustomerRequest()

  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <SvgIcon fontSize="small">
          <IconDotsVertical />
        </SvgIcon>
      </IconButton>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        {customerRequestStatuses.map((status) => (
          <ListItemButton
            key={status}
            onClick={() => updateRequest({ id, status }, { onSuccess: handleClose })}
            disabled={isPending}
          >
            {status}
          </ListItemButton>
        ))}
      </Menu>
    </>
  )
}
